import API from "@/api/lib/api";

export const getAllDishOfTheDays = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/dish-of-the-day`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleDishOfTheDay = async (id) => {
  try {
    const response = await API.get(`restaurant/dish-of-the-day/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createDishOfTheDay = async (data) => {
  try {
    const response = await API.post(`restaurant/dish-of-the-day`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateDishOfTheDay = async (id, data) => {
  try {
    const response = await API.put(`restaurant/dish-of-the-day/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteDishOfTheDay = async (id) => {
  try {
    const response = await API.delete(`restaurant/dish-of-the-day/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const filterByDay = async (restaurant_id, day_id) => {
  try {
    const response = await API.delete(
      `restaurant/${restaurant_id}/dish-of-the-day/day/${day_id}`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
